import {ResizeObserver} from '@juggle/resize-observer';
import useResizeObserver from 'use-resize-observer';
import {IS_CLIENT_SIDE} from '../utils/constants';

// https://github.com/ZeeCoder/use-resize-observer#transpilation--polyfilling 참고

if (IS_CLIENT_SIDE && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

export default useResizeObserver;
